import Cookies from "js-cookie";

// const BASE_URL = "https://api.flowchanger.com/api/";
// const BASE_URL = "http://localhost:8000/api/";
const BASE_URL = "https://fc-production-testing.onrender.com/api/";
const getHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
});

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "An unexpected error occurred");
  }
  return response.json();
};

const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const fetchAttendanceDetail = async (date, page = 1, limit = 4) => {
  const formattedDate = formatDate(date);
  const response = await fetch(
    `${BASE_URL}attendance/summary?type=day&date=${formattedDate}&page=${page}&limit=${999}`,
    {
      headers: getHeaders(),
      cache: "no-store",
    }
  );
  return handleResponse(response);
};


export const fetchDepartments = async () => {
  const response = await fetch(`${BASE_URL}department`, {
    headers: getHeaders(),
  });
  return handleResponse(response);
};

export const fetchFineDetails = async () => {
  const response = await fetch(`${BASE_URL}fine/all`, {
    headers: getHeaders(),
  });
  return handleResponse(response);
};

export const createFine = async (fineData) => {
  const response = await fetch(`${BASE_URL}fine/create`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(fineData),
  });
  return handleResponse(response);
};

export const fetchOverTimeDetails = async () => {
  const response = await fetch(`${BASE_URL}overtime`, {
    headers: getHeaders(),
  });
  return handleResponse(response);
};

export const createOvertime = async (overtimeData) => {
  const response = await fetch(`${BASE_URL}overtime/create`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(overtimeData),
  });
  return handleResponse(response);
};